<template>
  <md-dialog :md-active.sync="isShowAxiosLoading" :md-close-on-esc="false" :md-click-outside-to-close="false">
    <img src="../../assets/img/loading.gif" alt="" class="text-center" />
  </md-dialog>
</template>

<script>
  export default {
    name: 'AxiosLoading',
    props: {
      isShowAxiosLoading: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style scoped>
  .md-dialog {
    height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/globals/AxiosLoading.vue?23e86acf